import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findDataByMonth = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/placeMoney/findDataByMonth?` + params,
        method: 'GET'
    })
}
export const findData = () => {
    return request({
        url: `${baseUrl}/joins-product/v1/placeMoney/findData`,
        method: 'GET'
    })
}
export const rankingByGoodsName = () => {
    return request({
        url: `${baseUrl}/joins-product/v1/placeMoney/rankingByGoodsName`,
        method: 'GET'
    })
}
export const rankingByName = () => {
    return request({
        url: `${baseUrl}/joins-product/v1/placeMoney/rankingByName`,
        method: 'GET'
    })
}
export const numberCollect = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/placeMoney/numberCollect?` + params,
        method: 'GET'
    })
}
export const moneyCollect = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/placeMoney/moneyCollect?` + params,
        method: 'GET'
    })
}
export const findNumber = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/agentPromotion/findNumber?` + params,
        method: 'GET'
    })
}


